import { NxBadgeModule } from "@allianz/ng-aquila/badge";
import { NxGridModule } from "@allianz/ng-aquila/grid";
import { NxSpinnerModule } from "@allianz/ng-aquila/spinner";
import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { Select } from "@ngxs/store";
import moment from "moment";
import { Observable } from "rxjs";
import { CONSTANTS } from "src/app/shared/enums/index.enum";
import { CampaignState } from "src/app/store/campaign/campaign.state";

@Component({
  selector: "app-preview-campaign-card",
  templateUrl: "./preview-campaign-card.component.html",
  styleUrls: ["./preview-campaign-card.component.scss"],
  standalone: true,
  imports: [CommonModule, NxBadgeModule, NxGridModule, NxSpinnerModule],
})
export class PreviewCampaignCardComponent {
  @Input() public data;
  @Select(CampaignState.groupListing) protected groupListing$: Observable<any>;
  @Select(CampaignState.previewCampaign)
  protected previewCampaign$: Observable<any>;
  @Select(CampaignState.previewAsDate)
  protected previewAsDate$: Observable<any>;

  protected formatDate(date: Date, format: string) {
    return moment(date, CONSTANTS.YYYY_MM_DD_HH_MM_A).format(format);
  }

  protected identifyMomVariance(value: string, columnTitle: string) {
    if (columnTitle.toLowerCase().includes("variance")) {
      if (
        (value.startsWith("(") && value.endsWith(")")) ||
        value.startsWith("-")
      ) {
        return "red-value";
      } else {
        return "green-value";
      }
    }
  }
}
